import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, Output, EventEmitter, OnInit, Inject  } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-capella-filter',
  templateUrl: './capella-filter.component.html',
  styleUrls: ['./capella-filter.component.scss']
})
export class CapellaFilterComponent {

  capellaFormGroup: FormGroup;
  maxValue: boolean;
  wholeNumber: boolean;
  firstInput: number;
  secondInput: number;
  error: boolean;
  refreshError: boolean = true;
  focusedInput: 'start' | 'end' | null = null;
  sameValueError: boolean = false;
  
  @Input() operatorKey: any;
  @Input() displayTextPopup: string = '';
  @Output() formValid = new EventEmitter<boolean>();
  @Output() formValue = new EventEmitter<any>();
  @Output() applyFilter = new EventEmitter<any>();
  OPERATORS = {
    CAPELLA: 'Capella'
  };

  constructor(
    private dialogRef: MatDialogRef<CapellaFilterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    this.operatorKey = data?.operatorKey;
    this.displayTextPopup = data?.displayText;

  }
  ngOnInit() {
    this.capellaFormGroup = new FormGroup({
    collectionStart: new FormControl(null, [
      Validators.required,
      Validators.pattern(/^([0-9]|1[0-9]|2[0-4])$/)  // 0-24 only
    ]),
    collectionEnd: new FormControl(null, [
      Validators.required,
      Validators.pattern(/^([0-9]|1[0-9]|2[0-4])$/)
    ])
  });

     this.formValid.emit(this.capellaFormGroup.valid);

  //   this.capellaFormGroup.valueChanges.subscribe(() => {

  //     const startValue = this.capellaFormGroup.get('collectionStart')?.value;
  //     const endValue = this.capellaFormGroup.get('collectionEnd')?.value;

  //     const start = Number(startValue);
  //     const end = Number(endValue);

  //     this.error = false;
  //     this.maxValue = false;

  //     if (startValue !== '' && endValue !== '') {

  //       // max check
  //       if (start > 24 || end > 24) {
  //         this.maxValue = true;
  //         return;
  //       }
  //       // range check
  //       if (start > end) {
  //         this.error = true;
  //         this.capellaFormGroup.get('collectionEnd')?.setErrors({ range: true });
  //       } else {
  //         this.capellaFormGroup.get('collectionEnd')?.setErrors(null);
  //       }
  //     }
  //   });

  //   this.capellaFormGroup.statusChanges.subscribe(() => {
  //   const isValid = this.capellaFormGroup.valid;
  //   this.formValid.emit(this.capellaFormGroup.valid);
  //   this.formValue.emit(this.capellaFormGroup.value);
  // });
  // }

  this.capellaFormGroup.valueChanges.subscribe(() => {
    const startValue = this.capellaFormGroup.get('collectionStart')?.value;
    const endValue = this.capellaFormGroup.get('collectionEnd')?.value;

    this.error = false;
    this.maxValue = false;

    if (startValue !== null && endValue !== null) {
      const start = Number(startValue);
      const end = Number(endValue);

      if (start > 24 || end > 24) {
        this.maxValue = true;
        return;
      }

      if (start > end) {
        this.error = true;
        this.capellaFormGroup.get('collectionEnd')?.setErrors({ range: true });
      } else {
        this.capellaFormGroup.get('collectionEnd')?.setErrors(null);
      }
    }
  });
}

  isPositiveWholeNumber(value: number): boolean {    
    return value !== null && value >= 1 && value % 1 === 0;
  }
  onInputFocus(inputName: 'start' | 'end') {
    this.focusedInput = inputName;
  }

  onInputBlur(inputName: 'start' | 'end') {
    this.focusedInput = null;
  }
    onApply() {
    if (this.capellaFormGroup.valid) {
      this.dialogRef.close(this.capellaFormGroup.value);
    }
  }
  onCancel() {
    this.dialogRef.close();
  }
   onNoClick(): void {
    this.dialogRef.close('close');
  }
  onNumberInput(event: any, controlName: string) {
  let value = event.target.value;
  // Allow only digits, max 2 chars
  value = value.replace(/[^0-9]/g, '').slice(0, 2);
  event.target.value = value; // update native input

  this.capellaFormGroup.get(controlName)?.setValue(
    value === '' ? null : value,
    { emitEvent: true }
  );
  this.capellaFormGroup.get(controlName)?.markAsTouched();
}
}